import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assests/images/menubar_logo.png";
import "../Styles/MenuBar.css";
import { clearAllData, getData } from "../utils/store-data";
import { update_profile_active } from "../api/serverWrapper";
import LogoutModal from "../components/modals/LogoutModal";
import DisableAccountModal from "../components/modals/DisableAccountModal";
import CloseAccountModal from "../components/modals/CloseAccountModal";
import ReportIssueModal from "../components/modals/ReportIssueModal";
import TermsModal from "../components/modals/TermsModal";
import Resetpassword from "./Resetpassword";
import { USER_ID } from "../utils/store-data-constants";

export default function MenuBarforClient({
  client,
  setActiveTab,
  displayActiveTab,
  setDisplayActiveTabs,
  handleProfileId,
  setDisplayAprrovedProfile,
  MainProfile,
}) {
  const navigate = useNavigate();

  const [showSettings, setShowSettings] = useState(false);
  const settingsRef = useRef(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const [showDisableModal, setShowDisableModal] = useState(false);
  const [showCloseModal, setShowCloseModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [issueText, setIssueText] = useState("");
  const [activeMenu, setActiveMenu] = useState("");
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [userId, setUserId] = useState(null);

  // Close popup when clicking outside
  useEffect(() => {
    loadData();
    const handleClickOutside = (e) => {
      if (settingsRef.current && !settingsRef.current.contains(e.target)) {
        setShowSettings(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const loadData = async () => {
    const userId = await getData(USER_ID);
    setUserId(userId);
  };
  const LogOut = async () => {
    await clearAllData();
    navigate("/home");
  };

  const handleToggleAccountStatus = async () => {
    try {
      const isCurrentlyActive = client?.IsActive;

      const confirmMsg = isCurrentlyActive
        ? "Are you sure you want to deactivate this account?"
        : "Are you sure you want to activate this account?";

      if (!window.confirm(confirmMsg)) return;

      let data = {
        ProfileId: client.ProfileId,
        IsActive: !isCurrentlyActive, // TOGGLE
      };

      console.log("Payload:", data);

      const resp = await update_profile_active(data);
      console.log("Response:", resp);

      if (resp?.code === 200 || resp?.success) {
        alert(
          isCurrentlyActive
            ? "Account deactivated successfully"
            : "Account activated successfully",
        );

        window.location.reload(); // refresh to reflect active status
      } else {
        alert("Operation failed");
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  };

  return (
    <div>
      <header className="top-header d-flex justify-content-between align-items-center px-4 shadow-sm">
        <img
          src={logo}
          alt="WedLuk Logo"
          className="logos"
          style={{ height: "54px", cursor: "pointer" }}
        />

        <nav className="nav-menu d-flex gap-4 align-items-center">
          <span
            className={`nav-item ${
              displayActiveTab === "Matches" ? "active" : ""
            } click-effect`}
            onClick={() => {
              setDisplayActiveTabs("Matches");
              setActiveTab("matches");
              setDisplayAprrovedProfile(false);
            }}
          >
            Matches
          </span>

          {MainProfile?.AgentId && (
            <span
              className={`nav-item ${
                displayActiveTab === "My Agent" ? "active" : ""
              } click-effect`}
              onClick={() => {
                setDisplayActiveTabs("My Agent");
                setActiveTab("matches");
              }}
            >
              My Agent
            </span>
          )}

          <span
            className={`nav-item ${
              displayActiveTab === "Profile" ? "active" : ""
            } click-effect`}
            onClick={() => {
              setDisplayActiveTabs("Profile");
              setActiveTab("matches");
              handleProfileId(MainProfile?.ProfileId);
            }}
          >
            Profile
          </span>

          {/* SETTINGS */}
          <div
            className="nav-item position-relative click-effect"
            ref={settingsRef}
            onClick={() => setShowSettings(!showSettings)}
          >
            Settings
            {showSettings && (
              <div className="settings-popup shadow-sm">
                <div
                  className="settings-item "
                  onClick={() => {
                    setShowDisableModal(true);
                    setShowSettings(false);
                  }}
                >
                  Disable Account
                </div>

                <div
                  className="settings-item "
                  onClick={() => {
                    setShowCloseModal(true);
                    setShowSettings(false);
                  }}
                >
                  Close Account
                </div>
                <div
                  className="settings-item "
                  onClick={() => {
                    setShowReportModal(true);
                    setShowSettings(false);
                  }}
                >
                  Report Issue
                </div>
                <div
                  className="settings-item "
                  onClick={() => {
                    setShowReportModal(false);
                    setShowResetPassword(true);
                  }}
                >
                  Reset Password
                </div>
                {/* 
                <div
                  className="settings-item"
                  onClick={() => navigate("/home")}
                >
                  Switch account
                </div> */}

                <div
                  className="settings-item text-danger"
                  onClick={() => handleToggleAccountStatus()}
                >
                  {client?.IsActive ? "Deactivate Account" : "Activate Account"}
                </div>

                <div
                  className="settings-item"
                  onClick={() => {
                    setShowLogoutModal(true);
                    setShowSettings(false);
                  }}
                >
                  Logout
                </div>
              </div>
            )}
          </div>

          <LogoutModal
            isOpen={showLogoutModal}
            onClose={() => setShowLogoutModal(false)}
            onConfirm={LogOut}
          />

          <DisableAccountModal
            isOpen={showDisableModal}
            onClose={() => setShowDisableModal(false)}
            // onConfirm={() => {}}
            isProfile={client}
          />

          <CloseAccountModal
            isOpen={showCloseModal}
            onClose={() => setShowCloseModal(false)}
            onDisable={() => {
              setShowCloseModal(false);
              setShowDisableModal(true);
            }}
            onDelete={() => {}}
            isProfile={client}
          />

          <ReportIssueModal
            isOpen={showReportModal}
            onClose={() => setShowReportModal(false)}
            onSubmit={(issue) => {
              console.log(issue);
            }}
          />

          <TermsModal
            isOpen={showTermsModal}
            onClose={() => setShowTermsModal(false)}
          />
          <Resetpassword
            visible={showResetPassword}
            onClose={() => setShowResetPassword(false)}
            userId={userId}
          />
        </nav>
      </header>
    </div>
  );
}
